import { Pipe, PipeTransform } from '@angular/core';
import { ProductSelection } from '@features/opportunities/models/product-selection/product-selection.model';

@Pipe({
  name: 'hasSubmissionQuestionnaire'
})
export class HasSubmissionQuestionnairePipe implements PipeTransform {
  transform(productSelection: ProductSelection | null): boolean {
    // Define the base providers that always qualify for submission questionnaire
    const providers = ['liberty', 'mike pero', 'liberty commercial', 'nmb direct'];

    // Check if the product selection provider is in the qualifying providers list
    return productSelection !== null && providers.includes(productSelection.provider.toLowerCase());
  }
}
